import sticky from './_sticky';

export function stickySidebar() {
  const spacingEl = document.querySelector('.header-spacer');
  let spacing = 0;
  if(spacingEl) spacing = spacingEl.clientHeight

  const sidebarHome = document.querySelectorAll('.sticky-sidebar-home');
  if(sidebarHome.length) {
    sidebarHome.forEach((sb) => {
      new sticky(sb, {
        topSpacing: spacing,
        bottomSpacing: 0,
        containerSelector: '.sticky-container-home',
        minWidth: 1023
      });
    });
  }
}